import { render, staticRenderFns } from "./DownloadApk.vue?vue&type=template&id=22aa4df4"
import script from "./DownloadApk.vue?vue&type=script&lang=js"
export * from "./DownloadApk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports